import { jsx as t } from "react/jsx-runtime";
import { createContext as e } from "react";
const n = e(void 0), x = ({
  mapId: o,
  children: r
}) => /* @__PURE__ */ t(n.Provider, { value: o, children: r });
export {
  n as PLMapboxInternalMapIdContext,
  x as PLMapboxInternalMapIdProvider
};
//# sourceMappingURL=index.es20.js.map
